import styled from "styled-components"

const NoPointerEvents = styled.span`
  pointer-events: none;
`

export { NoPointerEvents }
